<template>
  <div class="grid">
    <div class="col-12">
      <Card>
        <template #title>Администрирование</template>
        <template #content>
          <TabView>
            <TabPanel header="Действия пользователей">
              <AbstractTable code="userActions" display-filter="menu">
                <template #user="row">
                  {{ row.data.surname }} {{ row.data.name }} {{ row.data.patronymic }}
                </template>
              </AbstractTable>
            </TabPanel>

            <TabPanel header="Создать нового пользователя">
              <CreateUserForm/>
            </TabPanel>
          </TabView>
        </template>
      </Card>
    </div>
  </div>
</template>

<script>
import AbstractTable from "@/components/AbstractTable.vue";
import CreateUserForm from "@/components/Forms/CreateUserForm.vue";

export default {
  name: "Admin",
  components: { CreateUserForm, AbstractTable },
  mounted() {
    if (this.$store.state.user?.role !== 'admin') {
      this.$router.push('/');
    }
  }
}
</script>

<style scoped>
</style>